import i18n from "i18n";

/**
 * Storing the current access property options
 */
const PositionAccessTypes = {
	get F() {
		return i18n.t("label.full");
	},
	get E() {
		return i18n.t("action.edit");
	},
	get R() {
		return i18n.t("label.readOnly");
	},
	get N() {
		return i18n.t("label.none");
	},
};

export default PositionAccessTypes;
